/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthProvider";
import DashboardTabToggle from "../dashboard/DashboardTabToggle";
import BarChartComponent from "../dashboard/BarChartComponent";
import LineChartComponent from "../dashboard/LineChartComponent";
import CardChartComponent from "../dashboard/CardChartComponent";
import DateRangeFilter from "../filters/DateRangeFilter";
import SelectFilter from "../filters/SelectFilter";
import UserDropdown from "../users/UserDropdown";
import FilterBadge from "../dashboard/FilterBadge";
import {
  getPatientDashboardData,
  getMostCommonItemData,
  getRegisterPerMonthData,
  getDashboardFiltersOptions
} from "../../services/dashboardService";
import CircularProgress from "@mui/material/CircularProgress";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import Box from "@mui/material/Box";
import "./PatientDashboard.css";

function PatientDashboard({ patientId }) {
  const { userToken } = useAuth();
  const [dashboardData, setDashboardData] = useState(null);
  const [activeTab, setActiveTab] = useState("Doenças");
  const [isLoading, setIsLoading] = useState(false);

  const [currentSelectedDoenca, setCurrentSelectedDoenca] = useState(null);
  const [currentSelectedMedicamento, setCurrentSelectedMedicamento] = useState(null);
  const [currentSelectedProcedimento, setCurrentSelectedProcedimento] = useState(null);
  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);

  const [doencaOptions, setDoencaOptions] = useState([]);
  const [medicamentoOptions, setMedicamentoOptions] = useState([]);
  const [procedimentoOptions, setProcedimentoOptions] = useState([]);

  const tabs = ["Doenças", "Medicamentos", "Procedimentos"];

  useEffect(() => {
    setFiltersOptions(userToken, patientId)
  }, []);

  const fetchDashboardData = async (
    tab = activeTab,
    selectedDoenca = currentSelectedDoenca,
    selectedMedicamento = currentSelectedMedicamento,
    selectedProcedimento = currentSelectedProcedimento,
    startDateFilter = currentStartDate,
    endDateFilter = currentEndDate
  ) => {
    setIsLoading(true);
    try {
      const data = await getPatientDashboardData(
        userToken,
        patientId,
        tab,
        selectedDoenca,
        selectedMedicamento,
        selectedProcedimento,
        startDateFilter,
        endDateFilter
      );
      setDashboardData(data);
      updateFilters(data);
    } catch (error) {
      console.error("Erro ao carregar os dados do dashboard:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    fetchDashboardData(tabName);
  };

  const cleanFilter = (fetch = true) => {
    setCurrentSelectedDoenca(null);
    setCurrentSelectedMedicamento(null);
    setCurrentSelectedProcedimento(null);
    setCurrentStartDate(null);
    setCurrentEndDate(null);
    if (fetch) fetchDashboardData(activeTab, null, null, null, null, null);
  };

  const handleBarClick = (item) => {
    cleanFilter(false);
    if (activeTab === "Doenças") {
      setCurrentSelectedDoenca([item]);
      fetchDashboardData(activeTab, [item]);
    } else if (activeTab === "Medicamentos") {
      setCurrentSelectedMedicamento([item]);
      fetchDashboardData(activeTab, currentSelectedDoenca, [item]);
    } else if (activeTab === "Procedimentos") {
      setCurrentSelectedProcedimento([item]);
      fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, [item]);
    }
  };

  const setFiltersOptions = async (token, patientId) => {
    const filtersOptions = await getDashboardFiltersOptions(token, patientId)
    const format = (list) => list.map((v) => ({ label: v, value: v }));
    setDoencaOptions(format(filtersOptions.doencaOptions));
    setMedicamentoOptions(format(filtersOptions.medicamentoOptions));
    setProcedimentoOptions(format(filtersOptions.procedimentoOptions));
  }

  const updateFilters = (data) => {
    setCurrentSelectedDoenca(data.doencaFilter);
    setCurrentSelectedMedicamento(data.medicamentoFilter);
    setCurrentSelectedProcedimento(data.procedimentoFilter);
    setCurrentStartDate(data.startDateFilter);
    setCurrentEndDate(data.endDateFilter);
  };

  const getCardChartPatientsSubtitle = (hidden) => {
    let title = "com registro de ";
    const items = [];
    if (dashboardData.doencaFilter) items.push(dashboardData.doencaFilter);
    if (dashboardData.medicamentoFilter) items.push(dashboardData.medicamentoFilter);
    if (dashboardData.procedimentoFilter) items.push(dashboardData.procedimentoFilter);
    if (items.length > 0) {
      let currentLength = title.length;
      let visibleItems = [];
      let hiddenCount = 0;
      for (const item of items[0]) {
        if (hidden || currentLength <= 40) {
          visibleItems.push(item);
          currentLength += item.length + 2;
        } else hiddenCount++;
      }
      title += visibleItems.join(", ");
      if (hiddenCount > 0) title += ` e mais ${hiddenCount}...`;
    } else {
      if (activeTab === "Doenças") return "com registro de doenças";
      if (activeTab === "Procedimentos") return "com registro de procedimentos";
      return "com registro de medicamentos";
    }
    return title;
  };

  const formatDateBR = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    fetchDashboardData(activeTab);
    // eslint-disable-next-line
  }, []);

  if (!dashboardData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="patient-dashboard-main-content">
      <div className="patient-dashboard-title-container">
        <h3 className="patient-dashboard-title">Dashboard do paciente</h3>
        <UserDropdown />
      </div>

      <div className="card patient-filters-card">
        <div className="filter-title-container">
          <h5 className="filter-title">Filtros</h5>
          <DashboardTabToggle tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
        </div>

        <div className="row filters-container">
          <SelectFilter title="Doença" currentSelected={currentSelectedDoenca} options={doencaOptions} onChange={(v) => { setCurrentSelectedDoenca(v); fetchDashboardData(activeTab, v); }} isClearable isMulti />
          <SelectFilter title="Medicamento" currentSelected={currentSelectedMedicamento} options={medicamentoOptions} onChange={(v) => { setCurrentSelectedMedicamento(v); fetchDashboardData(activeTab, currentSelectedDoenca, v); }} isClearable isMulti />
          <SelectFilter title="Procedimento" currentSelected={currentSelectedProcedimento} options={procedimentoOptions} onChange={(v) => { setCurrentSelectedProcedimento(v); fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, v); }} isClearable isMulti />
          <DateRangeFilter title="Período" onChangeStart={(v) => { setCurrentStartDate(v); fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, currentSelectedProcedimento, v, currentEndDate); }} onChangeEnd={(v) => { setCurrentEndDate(v); fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, currentSelectedProcedimento, currentStartDate, v); }} startDate={currentStartDate} endDate={currentEndDate} />
          <div className="filter-btn-container col-12 col-md-12 col-lg-1">
            <div className="btn btn-primary filter-btn" onClick={cleanFilter}>Limpar</div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 selected-filters d-flex flex-wrap gap-2 mt-3">
            {(currentSelectedDoenca || []).map((item, idx) => (
              <FilterBadge key={`doenca-${idx}`} label={item} category="Doença" onRemove={() => { const updated = currentSelectedDoenca.filter((_, i) => i !== idx); const newVal = updated.length ? updated : null; setCurrentSelectedDoenca(newVal); fetchDashboardData(activeTab, newVal); }} />
            ))}
            {(currentSelectedMedicamento || []).map((item, idx) => (
              <FilterBadge key={`med-${idx}`} label={item} category="Medicamento" onRemove={() => { const updated = currentSelectedMedicamento.filter((_, i) => i !== idx); const newVal = updated.length ? updated : null; setCurrentSelectedMedicamento(newVal); fetchDashboardData(activeTab, currentSelectedDoenca, newVal); }} />
            ))}
            {(currentSelectedProcedimento || []).map((item, idx) => (
              <FilterBadge key={`proc-${idx}`} label={item} category="Procedimento" onRemove={() => { const updated = currentSelectedProcedimento.filter((_, i) => i !== idx); const newVal = updated.length ? updated : null; setCurrentSelectedProcedimento(newVal); fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, newVal); }} />
            ))}
            {currentStartDate && (
              <FilterBadge
                label={`De ${formatDateBR(currentStartDate)}`}
                category="Data"
                onRemove={() => {
                  setCurrentStartDate(null);
                  fetchDashboardData(
                    activeTab,
                    currentSelectedDoenca,
                    currentSelectedMedicamento,
                    currentSelectedProcedimento,
                    null,
                    currentEndDate
                  );
                }}
              />
            )}

            {currentEndDate && (
              <FilterBadge
                label={`Até ${formatDateBR(currentEndDate)}`}
                category="Data"
                onRemove={() => {
                  setCurrentEndDate(null);
                  fetchDashboardData(
                    activeTab,
                    currentSelectedDoenca,
                    currentSelectedMedicamento,
                    currentSelectedProcedimento,
                    currentStartDate,
                    null
                  );
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="patient-dashboard-charts" style={{ position: "relative" }}>
        {isLoading && (
          <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(255,255,255,0.6)", backdropFilter: "blur(2px)", WebkitBackdropFilter: "blur(2px)", zIndex: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </div>
        )}

        <div className="card patient-most-common-graph-card">
          <div className="patient-graph-title-container">
            <Box style={{ color: "#0A91FF" }}>
              <TravelExploreIcon />
            </Box>
            <div className="patient-graph-title">{activeTab} mais frequentes</div>
          </div>
          <BarChartComponent options={getMostCommonItemData(dashboardData)} onBarClick={handleBarClick} />
        </div>

        <div className="patient-quantity-graph-card">
          <CardChartComponent title="Casos registrados" subtitle={<span>{getCardChartPatientsSubtitle()}</span>} value={dashboardData.totalCasesQuantity.toLocaleString("pt-BR")} />
        </div>

        <div className="card patient-time-graph-card">
          <div className="patient-graph-title-container">
            <Box style={{ color: "#5654D4" }}>
              <TroubleshootIcon />
            </Box>
            <div className="graph-title">
              <span>Quantidade de casos ao longo do tempo {getCardChartPatientsSubtitle()}</span>
            </div>
          </div>
          <LineChartComponent options={getRegisterPerMonthData(dashboardData)} onBarClick={handleBarClick} />
        </div>
      </div>
    </div>
  );
}

export default PatientDashboard;
